import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class SelectionService<T> {
  private selectedItems$ = new BehaviorSubject(new Map<string, T>());

  public getSelectedItems(): Observable<T[]> {
    return this.selectedItems$
      .asObservable()
      .pipe(map(items => [...items.values()]));
  }

  public isSelected(identifier: string): Observable<boolean> {
    return this.selectedItems$.pipe(map(items => items.has(identifier)));
  }

  public toggleSelection(identifier: string, item: T): void {
    const selectedItem = this.selectedItems$.value;
    if (selectedItem.has(identifier)) {
      selectedItem.delete(identifier);
    } else {
      selectedItem.set(identifier, item);
    }
    this.selectedItems$.next(selectedItem);
  }

  public clear() {
    this.selectedItems$.next(new Map());
  }
}
